// extracted by mini-css-extract-plugin
export default {"wrapperClass":"OmUBXCio1gw6F97xhrOA"};